import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const LoadingScreen: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        position: 'fixed',
        top: 0,
        left: 0,
        backgroundColor: '#ffffff',
        zIndex: 2000,
      }}
    >
      <CircularProgress sx={{ color: '#a31830' }} />
    </Box>
  );
};

export default LoadingScreen;